<template>
  <v-container fluid>
    <v-card class="mb-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">BL確認完了照会</h3>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search()"
          class="btn-search"
          v-permit.SHARP_BCI_SEARCH
        >{{$t('app.buttons.search')}}</v-btn>
        <v-btn @click="open()">BL確認完了メール出力</v-btn>
      </v-card-actions>
    </v-card>

    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="blNo" v-model="query.blNo"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker label="B/L DATE" v-model="query.blIssueDateFrom"></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker :min="query.blIssueDateFrom" label="~" v-model="query.blIssueDateTo"></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="doNo" v-model="query.doNo"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="Invoice NO" v-model="query.invoiceNo"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete label="SJL輸入担当" url="employees/kv" v-model="query.roleId"></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-card-text class="table-outer">
        <v-data-table
          :headers="headers"
          :items="results"
          :loading="loading"
          :pagination.sync="pagination"
          :rows-per-page-items="[10]"
          :total-items="pagination.totalItems"
          item-key="invoiceNo"
          select-all
          v-model="selected"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
            </td>
            <td>{{props.item.partnerName}}</td>
            <td>{{props.item.invoiceNo}}</td>
            <td>{{props.item.currencyCode}}</td>
            <td>{{props.item.amount | currency({symbol:'',fractionCount:2}) }}</td>
            <td>{{props.item.blNo}}</td>
            <td>{{props.item.blIssueDate}}</td>
            <td>{{props.item.doNo}}</td>
            <td>{{props.item.transportModeCode}}</td>
            <td>{{props.item.classification}}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <bl-dialog ref="bl"></bl-dialog>
  </v-container>
</template>
<script>
import BlDialog from './blDialog'
export default {
  components: {
    BlDialog
  },
  data() {
    return {
      selected: [],
      loading: false,
      headers: [
        { text: '海外取引先', value: 'partnerId', sortable: false },
        { text: 'Invoice NO', value: 'invoiceNo', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: 'Amount', value: 'amount', sortable: false },
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: 'B/L Date', value: 'blIssueDate', sortable: false },
        { text: 'D/O No', value: 'doNo', sortable: false },
        { text: '運送形態', value: 'transportModeId', sortable: false },
        { text: '物品名称', value: 'classification', sortable: false }
      ],
      query: {},
      pagination: {
        rowsPerPage: 10
      },
      results: [],
      showResults: []
    }
  },
  methods: {
    refresh() {
      this.selected = []
      this.load()
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: 'shipment.blNo,invoiceNo'
        }
      }
    },
    search() {
      this.pagination.page = 0
      this.$storeParams()
      this.load()
    },
    load() {
      this.autoload = true
      this.$http
        .get('/commercial-invoices?view=B1601', this.params())
        .then(res => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    open() {
      this.$refs.bl.popup().then(p => {
        this.$download(
          `/reports/bls?blIssueDateFrom=${p.from}&blIssueDateTo=${p.to}`
        )
      })
    }
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    }
  }
}
</script>
